// 🔹 Importar componente adPage
import { adPage, initadPage } from "./adPage.js";
import { renderPriceTab, initPriceSaveHandler } from "./priceTab.js";

// 📄 Estructura HTML para el panel de usuario con menú
export function dashboardPage() {
  return `
    <div id="user-dashboard" class="flex flex-col md:flex-row min-h-screen bg-gray-50">
      
      <!-- Menú lateral -->
      <aside class="md:w-64 w-full bg-gray-100 border-r border-gray-200 p-4 space-y-4">
        <h2 class="text-xl font-bold text-gray-800 mb-4">Mi Panel</h2>
        <nav class="space-y-2" id="dashboard-menu-nav">
          <button data-section="profile" class="menu-btn w-full text-left px-3 py-2 rounded hover:bg-blue-50 font-medium text-gray-700"><i class="fa fa-user mr-2"></i>Perfil</button>
          <!-- <button data-section="edit" class="menu-btn w-full text-left px-3 py-2 rounded hover:bg-blue-50 font-medium text-gray-700">✏️ Editar perfil</button> -->
          <button data-section="password" class="menu-btn w-full text-left px-3 py-2 rounded hover:bg-blue-50 font-medium text-gray-700"><i class="fa fa-lock mr-2"></i>Restablecer contraseña</button>

          <!-- 🔹 NUEVO ELEMENTO DEL MENÚ -->

          <button data-section="adpage" class="menu-btn w-full text-left px-3 py-2 rounded hover:bg-blue-50 font-medium text-gray-700">
            <i class="fa fa-bullhorn mr-2"></i>Anuncio
          </button>

          <!-- Nuevo elemento de menú para subir logo -->
          <button data-section="logoupload" class="menu-btn w-full text-left px-3 py-2 rounded hover:bg-blue-50 font-medium text-gray-700">
            <i class="fa fa-image mr-2"></i>Subir logo
          </button>

          <button data-section="logout" class="menu-btn w-full text-left px-3 py-2 rounded hover:bg-blue-50 font-medium text-gray-700 text-red-600"><i class="fa fa-sign-out-alt mr-2"></i>Cerrar sesión</button>
        </nav>

        <!-- Imagen del logo debajo del menú -->
        <div id="dashboard-logo-container" class="flex justify-center mt-6">
          <img id="dashboard-logo-img" src="" alt="Logo" style="width:150px;height:150px;object-fit:contain;display:none;border-radius:12px;border:1px solid #eee;" />
        </div>

          <!-- Streep onder logo -->
          <hr class="my-4 border-gray-300" />

          <!-- Hoofdtekst Herramientas HVAC -->

      </aside>

      <!-- Contenido principal -->
      <main class="flex-1 p-6" id="dashboard-content">
        <p class="text-gray-500 text-center">Cargando...</p>
      </main>
    </div>
  `;
}


// ⚙️ Lógica para obtener, mostrar y editar datos
export async function initDashboard() {
      // 🔹 Prijzen tonen en bewerken
      async function renderPrices() {
        try {
          const res = await fetch(`${API_BASE}/advisor/prices`, {
            credentials: "include",
          });

          const existingPrices = res.ok ? await res.json() : [];

          content.innerHTML = renderPriceTab(existingPrices);

          // advisor_id NIET uit UI halen, maar uit sessie / profile
          const advisorId =
            existingPrices[0]?.advisor_id || window.loggedInUserId;

          initPriceSaveHandler(advisorId);

        } catch (err) {
          console.error(err);
          content.innerHTML =
            `<p class="text-red-600">Error cargando precios</p>`;
        }
      }
    // Helper: update logo in menu
function updateDashboardLogo(url) {
  const logoImg = document.getElementById("dashboard-logo-img");

  if (!url) {
    logoImg.src = "https://ceecasasespana.com/logos/LogoES.webp";
    logoImg.style.display = "block";
    return;
  }

  // Als de backend alleen de bestandsnaam geeft
  if (!url.startsWith("http") && !url.startsWith("/")) {
    url = `/logos/${url}`;
  }

  logoImg.src = url;
  logoImg.style.display = "block";
}

  const content = document.getElementById("dashboard-content");
  if (!content) return;

  const API_BASE =
  window.location.hostname === "localhost"
    ? "http://localhost:4000/api"
    : "/api";

  // 🔹 Obtener perfil mediante COOKIE
  async function fetchProfile() {
    try {
      const res = await fetch(`${API_BASE}/dashboard`, {
        method: "GET",
        credentials: "include",
      });

      if (!res.ok) throw new Error("No se pudo cargar el perfil.");

      const data = await res.json();
      if (!data.user) throw new Error("No has iniciado sesión");
      return data.user;

    } catch (err) {
      // Verberg menu en redirect naar /register/
      const menu = document.getElementById("dashboard-menu-nav");
      if (menu) menu.classList.add("hidden");
      window.location.href = "/register/";
      return null;
    }
  }

  // 🔹 Vista de perfil
  async function renderProfile() {
    const user = await fetchProfile();

    // Guardar user_id globalmente para adPage.js
    window.loggedInUserId = user.id;
    window.loggedInUserEmail = user.email;

    // Haal logo uit /company/me
    let logoUrl = "";
    try {
      const companyRes = await fetch(`${API_BASE}/company/me`, { credentials: "include" });
      if (companyRes.ok) {
        const companyJson = await companyRes.json();
        if (companyJson.success && companyJson.company && companyJson.company.logo) {
          logoUrl = companyJson.company.logo;
        }
      }
    } catch (e) {
      // fallback: geen logo
    }

    content.innerHTML = `
      <div class="max-w-lg mx-auto bg-white shadow-md p-6 rounded-xl border border-gray-200">
        <h2 class="text-2xl font-bold text-gray-800 mb-4">Bienvenido, ${user.name} 👋</h2>
        <p class="text-gray-600 mb-6">Aquí puedes ver tus datos.</p>
        <div class="space-y-2 text-gray-700">
          <p><strong>Nombre:</strong> ${user.name}</p>
          <p><strong>Email:</strong> ${user.email}</p>
        </div>
      </div>
    `;
    updateDashboardLogo(logoUrl ? `/logos/${logoUrl}` : "");

    // Toon logo in menu als het bestaat
    if (logoUrl) {
      updateDashboardLogo(logoUrl);
    } 
  }


  // 🔹 Editar perfil
  async function renderEditProfile() {
    const user = await fetchProfile();
    content.innerHTML = `
      <div class="max-w-lg mx-auto bg-white shadow-md p-6 rounded-xl border border-gray-200">
        <h2 class="text-2xl font-bold text-gray-800 mb-4">Editar perfil</h2>
        <form id="edit-form" class="space-y-4">
          <div>
            <label class="block text-sm font-semibold text-gray-700">Nombre</label>
            <input type="text" id="name" value="${user.name}" class="w-full border rounded p-2" required />
          </div>
          <div>
            <label class="block text-sm font-semibold text-gray-700">Email</label>
            <input type="email" id="email" value="${user.email}" class="w-full border rounded p-2" required />
          </div>
          <button type="submit" class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">Guardar</button>
        </form>
      </div>
    `;

    document.getElementById("edit-form").addEventListener("submit", async (e) => {
      e.preventDefault();
      const updated = {
        name: document.getElementById("name").value,
        email: document.getElementById("email").value,
      };

      try {
        const res = await fetch(`${API_BASE}/update-user`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(updated),
        });

        if (!res.ok) throw new Error("Error al guardar el perfil.");

        alert("✅ ¡Perfil actualizado correctamente!");
        renderProfile();

      } catch (err) {
        console.error(err);
      }
    });
  }


  // 🔹 Restablecer contraseña
  function renderPasswordReset() {
    content.innerHTML = `
      <div class="max-w-lg mx-auto bg-white shadow-md p-6 rounded-xl border border-gray-200">
      <h2 class="text-2xl font-bold text-gray-800 mb-4">Restablecer contraseña</h2>
      <form id="password-form" class="space-y-4">
      <div>
      <label class="block text-sm font-semibold text-gray-700">Nueva contraseña</label>
      <input type="password" id="new-password" class="w-full border rounded p-2" required />
      </div>
      <div>
      <label class="block text-sm font-semibold text-gray-700">Confirmar contraseña</label>
      <input type="password" id="confirm-password" class="w-full border rounded p-2" required />
      </div>
      <button type="submit" class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
      Restablecer contraseña
      </button>
      </form>
      </div>
    `;

    document.getElementById("password-form").addEventListener("submit", async (e) => {
      e.preventDefault();
      const newPassword = document.getElementById("new-password").value;
      const confirm = document.getElementById("confirm-password").value;

      if (newPassword !== confirm) {
        alert("❌ ¡Las contraseñas no coinciden!");
        return;
      }

      // Email desde window
      let email = window.loggedInUserEmail;
      if (!email) {
        try {
          const user = await fetchProfile();
          email = user.email;
        } catch {
          alert("❌ No se pudo obtener el correo.");
          return;
        }
      }

try {
  const res = await fetch(`${API_BASE}/resetPassword`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
body: JSON.stringify({ 
  email, 
  password: newPassword,
  confirmPassword: confirm 
}),
  });

  if (!res.ok) throw new Error("Error al cambiar la contraseña.");

  alert("✅ ¡Contraseña cambiada con éxito!");

} catch (err) {
  console.error(err);
  alert("❌ Error al cambiar la contraseña.");
}

    });
  }


  // 🔹 Logout
  function handleLogout() {
    window.location.href = "/portaal/login";
  }


  // 🔹 Mostrar pagina voor logo uploaden
  function renderLogoUpload() {
    content.innerHTML = `
      <div class="max-w-lg mx-auto bg-white shadow-md p-6 rounded-xl border border-gray-200">
      <h2 class="text-2xl font-bold text-gray-800 mb-4">Subir logo</h2>
      <form id="logo-upload-form" class="space-y-4">
        <input type="file" id="logoUploader" accept="image/*" required />
        <button type="submit" class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">Subir</button>
      </form>
      </div>
    `;

    const logoUploader = document.getElementById("logoUploader");
    document.getElementById("logo-upload-form").addEventListener("submit", async function (e) {
      e.preventDefault();
      const file = logoUploader.files[0];
      if (!file) {
        return alert("Selecciona un archivo.");
      }
      const uploadForm = new FormData();
      uploadForm.append("logo", file);
      try {
        const upRes = await fetch(`${API_BASE}/upload-logo`, {
          method: "POST",
          credentials: "include",
          body: uploadForm,
        });

        if (!upRes.ok) {
          const text = await upRes.text();
          console.error("❌ Upload error:", upRes.status, text);
          alert("La carga del logo ha fallado.");
          return;
        }
        const data = await upRes.json();
        updateDashboardLogo(data.url);
        alert("✅ ¡Logo subido correctamente!");
      } catch (err) {
        console.error("❌ Network error:", err);
        alert("La carga del logo ha fallado.");
      }
    });
  }

  // 🔹 Mostrar pagina de anuncio
  function renderAdPage() {
    content.innerHTML = adPage();
    initadPage();
  }

  // 🔹 Eventos del menú
  document.querySelectorAll(".menu-btn").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const section = e.target.dataset.section;

      document.querySelectorAll(".menu-btn").forEach(b =>
        b.classList.remove("bg-blue-100", "text-blue-700")
      );
      e.target.classList.add("bg-blue-100", "text-blue-700");

      if (section === "profile") renderProfile();
      //if (section === "edit") renderEditProfile();
      if (section === "password") renderPasswordReset();
      if (section === "adpage") renderAdPage();
      if (section === "logoupload") renderLogoUpload();
      if (section === "prices") renderPrices();
      if (section === "logout") handleLogout();
    });
  });

  // 🔹 Event voor HVAC menu-item
  // (verwijderd: HVAC knop event, vervangen door link)

  // 🔹 Mostrar perfil por defecto
  renderProfile();
}
